/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, ViewChild} from '@angular/core';
import {NgModule} from '@angular/core';
import {GMapModule, DataTableModule,ButtonModule,PaginatorModule,DropdownModule, PanelModule} from "primeng/primeng";
import {FormsModule, FormGroup, ReactiveFormsModule, FormBuilder, FormControl, Validators} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";
import { MamAdminService } from '../../service/mam_service.component';
import { MamVisitorService } from '../../service/mam_visitor_service.component';
import {CommonModule, DatePipe} from "@angular/common";
import {SearchModule} from "../../component/search.component";
import { VisitorLocation } from '../../model/visitorLocation';
import {SelectItem} from "primeng/components/common/api";
import {TranslateServiceForm, TranslatePipeMoudle} from "../../translate";
import { ExDialogModule } from  '../../component/dialog.component';
import {SearchDropBoxModule} from "../../component/search_dropbox.component";
import {Paginator} from "primeng/components/paginator/paginator";
import { ReservedVisitor } from '../../model/reserved_visitor';
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS
import {MainPipeMoudle} from "../../pipe/main.pipe";
import * as glob from "../../service/global_url";

declare var google: any;

@Component({

selector: 'visitor-location-verification',
templateUrl: 'location_verification.html'
})
export class VisitorLocationVerificationComponent implements  OnInit{

  //model
  visitorLocationList : VisitorLocation[] = [];
  detailSelected : VisitorLocation;
  
  // dialog
  detailShow : boolean = false;
  dialogWidth : number = 700;
  title : string;

  // filter
  searchIsTrue : boolean;
  searchKeyword: string;
  searchValue : string;
  searchValueIsDropBox: boolean;
  searchTextfiledIsUse: boolean;
  searchId: number;

  dateIsTrue : boolean = true;
  startDate: string;
  endDate: string;

  // filter item
  searchIDs: SelectItem[];
  visitorTypeList : SelectItem[];
  searchValueDropBox : SelectItem[];

  // paging
  listTotalCount: number;
  rowNum: number;
  pageNum: number;
  @ViewChild('paginator') paginator: Paginator;

  // global constant flag
  private visitorInfoModifyIsTrue : boolean = glob.visitorInfoModifyIsTrue;



  @ViewChild("gmap") googleMap : any;
  translate:TranslateServiceForm;

  constructor(private service : MamVisitorService, private fb: FormBuilder, private _translate: TranslateServiceForm, private logger : Logger) { 
    this.translate = _translate;

    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('LANG_VISITOR_PhoneNumber'), value: 'mobileNumber'});
    // this.searchIDs.push({label: this.translate.instant('LANG_VISITOR_Type'), value: 'visitorType'});
    
    this.visitorTypeList = [];
    this.visitorTypeList.push({label: '---------------', value: ''});
    this.visitorTypeList.push({label: this.translate.instant('LANG_VISITOR_Type_Common'), value: '0'});
    this.visitorTypeList.push({label: this.translate.instant('LANG_VISITOR_Type_Regular'), value: '1'});
    
    this.rowNum = 10;
    this.pageNum = 0;
    this.getVisitorLocationList();
  }

  ngOnInit(): void {
  }
  
  //event///////////////////////////////////////
  paginate(event) {
    this.logger.debug(event);
    this.rowNum = event.rows;
    this.pageNum = event.page;
    this.getVisitorLocationList();
  }
 
  searchKeywordChange(data) {
    this.logger.debug("data => ", data);
    if (data == 'visitorType') {
      this.searchValueDropBox = this.visitorTypeList;
      this.searchTextfiledIsUse = false;
      this.searchValueIsDropBox = true;
    } else if(data == 'all' || !data) {
      this.searchTextfiledIsUse = false;
      this.searchValueIsDropBox = false;
    } else {
      this.searchTextfiledIsUse = true;
      this.searchValueIsDropBox = false;
    }
  }
  
  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchKeyword = event.searchId;
    this.searchValue = event.searchText;
    this.startDate = event.sDate;
    this.endDate = event.eDate;
    this.searchId = event.searchId;
//    this.logger.debug(this.searchId)

    if(this.endDate < this.startDate ) {
      alert(this.translate.instant('MESSAGE_LastDate_Less_StartDate'));
      return;
    }
    //this.paginator.changePageToFirst({});
    this.pageNum = 0;
    this.getVisitorLocationList();
  }
  
  releasePolicy(data, isFree:boolean) {
    this.logger.debug("-- isFree : " + isFree);
    
    if (isFree) {
      // 정책 해제
      this.updateLocationStatus(data.id, 1);
    } else {
      this.updateLocationStatus(data.id, 2);
    }
  }
  
  showDetail(data) {
    let pos = new google.maps.LatLng(data.latitude, data.longitude);
    let gpsOption = {
      center: pos,
      zoom: 17
    };

    let map = new google.maps.Map(this.googleMap.el.nativeElement.children[0], gpsOption);

    new google.maps.Marker({
      position: new google.maps.LatLng(data.latitude, data.longitude),
      map: map
    });

    this.googleMap.map = map;

    this.detailShow = true;
    this.dialogWidth = 600;
    this.detailSelected = data;
    this.title = this.translate.instant('LANG_Detail');
  }
  
  hideDialog(event){
    this.detailShow = false;
  }

  /////////////////////////////////////////////


  updateLocationStatus(locationId:number, status:number) {
    this.service.updateLocationStatus(locationId, status).subscribe(
        value => {
          if (status == 1) {
            alert(this.translate.instant('MESSAGE_VISITOR_LocationStatus_Approved'));
          } else if (status == 2) {
            alert(this.translate.instant('MESSAGE_VISITOR_LocationStatus_Unapproved'));
          }
        },
        error => {
          let result = error.json();
          this.logger.error("-- error : " + error);
          alert(result.message);
        },
        () => {
          this.getVisitorLocationList();
        }
    )
  }

  getVisitorLocationList(){
    var urlPath = "/visitor-location/request";
    this.service.getList(urlPath, this.pageNum, this.rowNum, this.searchKeyword, this.searchValue, this.startDate, this.endDate)
    .subscribe(
      value => {
        if (value != null) {
          this.visitorLocationList = value.data.content;
          this.listTotalCount = value.data.totalElements;
          this.logger.debug(this.listTotalCount);  
        } else {
          this.visitorLocationList = [];
          this.listTotalCount = 0;
        }
      },
      error => {
        let result = error.json();
        this.logger.error("-- error : " + error);
        alert(result.message);
      },
      () => {}
    );
  }

}
@NgModule({
  imports: [GMapModule, SearchDropBoxModule, DataTableModule,ButtonModule,HttpModule,BrowserModule, CommonModule,PaginatorModule,DropdownModule,FormsModule,SearchModule, ReactiveFormsModule, ExDialogModule, PanelModule, MainPipeMoudle, TranslatePipeMoudle],
  exports: [VisitorLocationVerificationComponent],
  declarations: [VisitorLocationVerificationComponent],
  providers: [MamAdminService],
})
export class VisitorLocationModule {
}



// WEBPACK FOOTER //
// ./src/app/page/visitor/location_verification.ts